import React from "react";
import MainList from "components/MainList";
import columns from "./columns";

const Alerts = ({id}) => {

  return (
    <MainList
      columns={columns}
      query_name={`/users/${id}/alerts`}
      query_path={`/users/${id}/alerts`}
      query_context="index"
      with_navigation={false}
    />
  );
};

export default Alerts;
